module.exports = __webpack_public_path__ + "img/blog_review_top.be38c62e.jpg";